export function ZoomCtrl({ k, onZoomIn, onZoomOut, onFit }) {
  return (
    <div className="zoom-ctrl">
      <button type="button" onClick={onZoomOut} aria-label="Zoom out">−</button>
      <div className="pct">{Math.round(k * 100)}%</div>
      <button type="button" onClick={onZoomIn} aria-label="Zoom in">+</button>
      <button type="button" onClick={onFit} aria-label="Fit" title="Fit">⊡</button>
    </div>
  );
}

export default ZoomCtrl;
